export enum ServiceType {
    TAKEAWAY = 'TAK101',
    DELIVERY = 'DEL101',
    DINEIN = 'DIN101'
}

